import React, { useState, Children, cloneElement } from 'react';
import cl from './Tabs.module.css';

/**
 * Usage:
 * <Tabs initialIndex={0}>
 *   <Tab label="Home">…home content…</Tab>
 *   <Tab label="Profile">…profile content…</Tab>
 *   <Tab label="Settings">…settings content…</Tab>
 * </Tabs>
 */
export const Tab = ({ children }) => children;

const Tabs = ({ children, initialIndex = 0 }) => {
  const [activeIndex, setActiveIndex] = useState(initialIndex);
  const tabs = Children.toArray(children);

  return (
    <div className={cl.tabs}>
      <div className={cl.tabList}>
        {tabs.map((tab, idx) => (
          <button
            key={idx}
            className={`${cl.tabButton} ${activeIndex === idx ? cl.activeTab : ''}`}
            onClick={() => setActiveIndex(idx)}
          >
            {tab.props.label}
          </button>
        ))}
      </div>
      <div className={cl.tabContent}>
        {tabs[activeIndex].props.children}
      </div>
    </div>
  );
};

export default Tabs;
